import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";

/**
 * A component to render phone inputs. It should handle phone number formatting and country flag/code selections.
 *
 * @param {Object} props
 * @param {string} props.label - The label to be displayed on top of the input
 * @param {string} props.value - The current value of the phone, as the component is controlled
 * @param {(value: string)=>{}} props.onChange - A function that runs when the selected option changes
 * @param {string} props.name - The HTML name of the input
 * @param {boolean} props.required - Whether the input is required or not @default true
 * @param {string} props.className - CSS classes for the phone input container
 * @param {string | undefined} props.error - The error to be displayed
 * @param {boolean} props.touched - Whether the input was touched or not
 * @param {boolean} props.disabled - Whether the input is disabled or not @default false
 * @returns {JSX.Element}
 */

const AppPhoneInput = ({
  onChange,
  value,
  name,
  required = true,
  label,
  className,
  hideLabel,
  error,
  touched,
  disabled = false,
}) => {
  const { t } = useTranslation("global");
  return (
    <div className={className}>
      {!hideLabel && <label htmlFor={name}>{label}</label>}
      <div>
        <PhoneInput
          country="sa" // Default country
          countryCodeEditable={false}
          disableDropdown={true} // Disable country selection
          value={value}
          onChange={onChange}
          inputProps={{
            name: name,
            required: required,
            autoFocus: true,
            style: {
              width: "100%",
              backgroundColor: disabled ? "rgba(0, 0, 0, 0.04)" : "white",
            },
          }}
          containerStyle={{
            zIndex: 20,
          }}
          disabled={disabled} // Also try this prop if needed
        />
      </div>
      {error && touched && (
        <p className="text-text_warning text-sm mt-1 text-start">{t(error)}</p>
      )}
    </div>
  );
};

export default AppPhoneInput;
